import React, { Component } from 'react';
import queryString from 'query-string';
import { Col, Grid, Row } from 'react-bootstrap';

import { Redirect } from 'react-router-dom'
import { funcionContext } from '../../context/funcionContext'



export class EliminaSuscripcion extends Component {
    displayName = EliminaSuscripcion.name

    constructor(props) {
        super(props);

        const values = queryString.parse(this.props.location.search);

        this.state = {
            Origen: 'CORREO',
            Observacion: 'Registro generado automaticamente correo',
            Login: 'PRCSMS',
            nControl: values.ref,
            Correo: values.ref2,
            loading: true,
            infoValida: false,
            token: values.ref3   //'1905C889-E348-4719-8397-347ACCFFB580'
        };

        console.log(this.state);

        console.log(values);
    }

    componentDidMount() {


        console.log('ok')
        debugger

        const Correo = this.state.Correo;
        const Token = this.state.token;





        if (Correo != undefined) {

            var LstNegraData = {
                CORREO_ELECTRONICO: this.state.Correo,
                ORIGEN: this.state.Origen,
                OBSERVACION: this.state.Observacion,
                LOGIN_CREACION: this.state.Login
            };


            var data = new FormData();
            data.append("json", JSON.stringify(LstNegraData));
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorizedtoken': this.state.token,
                    'user': window.env.API_USER,
                    'refnumber': this.state.nControl
                },
                contentType: "application/json",
                body: JSON.stringify(LstNegraData)

            };

            fetch(window.env.API_DOMAIN_ADDR + '/api/Confirmacion/InsertListaNegra', requestOptions)
                .then(response => response.json())
                .then(dataRes =>

                    this.setState({
                        data: dataRes,
                        loading: false,
                        infoValida: true
                    })
            );


        } else {

            this.setState({
                data: { Codigo: 400, Mensaje: '' },
                infoValida: false
            })

    
        }


        console.log(this.setState)




    }

    //API_DOMAIN_ADDR: "https://localhost:44393",  

    //window.env.API_DOMAIN_ADDR +
    // 'https://localhost:44329'
    //https://localhost:44356/

    static renderMsjEliminaSuscripcion(c) {
        return (


            <div className="contentbody">
                <div className="full_header">
                    <img className="escritorio" src="/media/images/escritorio/fondo_mensaje_final.png" />
                    <img className="movil" src="/media/images/mensaje_final.png" />
                    <img className="movil-lanscape" src="/media/images/escritorio/fondo_bienvenido.png" />
                </div>
                <div className="content-full">
                    <img className="img_header" src="/media/images/Logo_servi.png" />
                    <div style={{ backgroundImage: "url('/media/images/escritorio/Fondo_mensajefinal.png')" }} className="msjFinal">
                        <div id="img_confirmado" style={{ width: "30%", float: "left" }}>
                            <img style={{ width: "100%" }} src="/media/images/Ex_onfirmado.png" />
                        </div>
                        <div id="msj_confirmado" style={{ width: "70%", float: "right", paddingRight: "1em" }}>
                            <img src="/media/images/informacion.png" />
                            <label className="final_label">"De acuerdo a su solicitud, hemos eliminado esta dirección de correo de nuestros registros para enviar comunicaciones."</label>
                            <label style={{ fontSize: "0.7em" }} className="final_label"></label>
                        </div>

                        <div id="img_confirmado_movil">
                            <img className="logoAcepta" src="/media/images/Logo_servi.png" />
                            <img className="expAcepta" src="/media/images/Ex_onfirmado.png" />
                        </div>
                    </div>
                </div>
            </div>

        );
    }

    static renderCorreoInvalido() {
        console.log('correo invalido');
        return (

            <div className="contentbody">
                <div className="full_header">
                    <img className="escritorio" src="/media/images/escritorio/fondo_mensaje_final.png" />
                    <img className="movil" src="/media/images/mensaje_final.png" />
                    <img className="movil-lanscape" src="/media/images/escritorio/fondo_bienvenido.png" />
                </div>
                <div className="content-full">
                    <img className="img_header" src="/media/images/Logo_servi.png" />
                    <div style={{ backgroundImage: "url('/media/images/escritorio/Fondo_mensajefinal.png')" }} className="msjFinal">
                        <div id="img_confirmado" style={{ width: "30%", float: "left" }}>
                            <img style={{ width: "100%" }} src="/media/images/Ex_onfirmado.png" />
                        </div>
                        <div id="msj_confirmado" style={{ width: "70%", float: "right", paddingRight: "1em" }}>
                            <img src="/media/images/informacion.png" />
                            <label className="final_label">Este email no es valido.</label>
                            <label style={{ fontSize: "0.7em" }} className="final_label"></label>
                        </div>

                        <div id="img_confirmado_movil">
                            <img className="logoAcepta" src="/media/images/Logo_servi.png" />
                            <img className="expAcepta" src="/media/images/Ex_onfirmado.png" />
                        </div>
                    </div>
                </div>
            </div>


        );
    }

    static renderError() {
        return (
            <div className="contentbody">
                <div className="full_header">
                    <img className="escritorio" src="/media/images/escritorio/fondo_mensaje_final.png" />
                    <img className="movil" src="/media/images/mensaje_final.png" />
                </div>
                <div className="content-full">
                    <img className="img_header" src="/media/images/Logo_servi.png" />
                    <div style={{ backgroundImage: "url('/media/images/escritorio/Fondo_mensajefinal.png')" }} className="msjFinal">
                        <img src="/media/images/informacion.png" />
                        <label className="final_label">Ha ocurrido un error Intentelo nuevamente</label>
                    </div>
                </div>
            </div>
        );
    }


    static renderInvalido() {
        return (
            <div>No tiene acceso para ver esta página</div>
        );
    }


    renderMsjFinal(ctx) {



            if (this.state.data.codigo == 200) {
                return ctx.renderMsjEliminaSuscripcion(this);
            }
            else if (this.state.data.codigo == 300) {

                return ctx.renderCorreoInvalido()
            }
            else {
                return ctx.renderError();
            }



    }



    render() {


       let content = this.state.loading ? <p><em>loading...</em></p> : this.renderMsjFinal(EliminaSuscripcion);

        return (
            <div>
                {content}
            </div>
        );
    }



}

